import React from "react";
import composite from "../img/composite.png";

export default function () {
  return <div className="not-found">404</div>;
}
